// extracted by mini-css-extract-plugin
export var header = "ToolsSection-module--header--0xoOw";
export var img = "ToolsSection-module--img--oe3Sh";